<template>
  <div class="po-r w100">
    <div class="w100 pb10 flex-box al-t" v-if="siftData.length > 0">
      <SiftComp class="flex-1 pr10" ref="sift" :sift-data="siftData" :searching="loading" @click-search="fetchList"></SiftComp>
      <div>
        <el-button type="success" size="mini" @click="download">导出</el-button>
        <el-button type="primary" @click="initPage()">查询</el-button>
      </div>
    </div>
    <el-table class="w100 tx-c my-table" :data="list" cell-class-name="cu-p" stripe border @row-click="clickRow">
      <el-table-column align="center" label="服务名称" prop="processDefName" width="150px"></el-table-column>
      <el-table-column align="center" label="事务标题" prop="processTitle"></el-table-column>
      <el-table-column align="center" label="流程状态" prop="state" width="100px">
        <template slot-scope="scope">
          <span class="blue" v-if="scope.row.processState == 0" key="state">处理中</span>
          <span class="green" v-else-if="scope.row.processState == 1" key="state">已完成</span>
          <span class="grey" v-else key="state">已终止</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="我经办的步骤" prop="step">
        <template slot-scope="scope">
          第{{ scope.row.nodeNo }}步：{{ scope.row.nodeName }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="申请人" prop="createUserName" width="100px"></el-table-column>
      <el-table-column align="center" label="申请时间" prop="stopTime" width="180px">
        <template slot-scope="scope">
          {{ scope.row.createTime | filterDate('yyyy-MM-dd hh:mm:ss') }}
        </template>
      </el-table-column>
    </el-table>
    <div class="w100 mt20 tx-r">
      <el-pagination @size-change="changeSize" @current-change="changePage" :current-page="page" :page-sizes="[10, 20, 30, 50, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" background :total="total"></el-pagination>
    </div>
    <a class="none" ref="downloadExcel" :href="downloadUrl"></a>
    <el-dialog :visible.sync="isShow" width="1000px" top="10px" :close-on-click-modal="false">
      <iframe ref="iframe" class="iframe" :src="isShow ? iframeUrl : ''"></iframe>

      <ProcessDialog ref="processDialog" />
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import SiftComp from "@/components/CompSift/SiftComp";
import ProcessDialog from "@/components/Public/ProcessDialog";

export default {
  name: "CardMyOfficeSWCX",
  components: {
    SiftComp,
    ProcessDialog,
  },
  props: {},
  data() {
    return {
      siftData: [],

      loading: false,

      label: [],
      list: [],
      page: 1,
      size: 20,
      total: 0,

      isShow: false,
      iframeUrl: "",

      downloadUrl: "",
    };
  },
  computed: {
    ...mapState(["userToken"]),
  },
  mounted() {
    this.fetSiftData();
  },
  methods: {
    fetSiftData() {
      this.loading = true;
      this.$http
        .post("newTask/getSiftData")
        .then(({ data }) => {
          // console.log(data);
          if (data.RetCode) {
            for (const i in data.RetData.siftData) {
              if (data.RetData.siftData[i].type == "select") {
                data.RetData.siftData[i].data = [
                  { label: "全部", value: "" },
                  ...data.RetData.siftData[i].data,
                ];
              }
            }
            this.siftData = data.RetData.siftData;
            this.$nextTick(() => {
              this.initPage();
            });
          } else {
            this.$notify({
              title: "温馨提示",
              message: data.RetMsg,
              type: "error",
              offset: 60,
              duration: 3000,
            });
            this.loading = false;
          }
        })
        .catch(() => {
          this.$notify({
            title: "温馨提示",
            message: "网络连接错误，请检查网络",
            type: "error",
            offset: 60,
            duration: 3000,
          });
          this.loading = false;
        });
    },
    fetchList() {
      this.loading = true;
      let obj = {};
      if (this.siftData.length > 0) {
        obj = this.$refs.sift.clickSearchBtn();
      }
      obj.pageNum = this.page;
      obj.pageSize = this.size;

      this.$http
        .post("newTask/taskQueryPage", this.$qs.stringify(obj))
        .then(({ data }) => {
          // console.log(data);
          if (data.RetCode) {
            this.list = data.RetData.list;
            this.total = data.RetData.total;
          } else {
            this.$notify({
              title: "温馨提示",
              message: data.RetMsg,
              type: "error",
              offset: 60,
              duration: 3000,
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.$notify({
            title: "温馨提示",
            message: "网络连接错误，请检查网络",
            type: "error",
            offset: 60,
            duration: 3000,
          });
          this.loading = false;
        });
    },
    initPage() {
      this.list = [];
      this.page = 1;
      this.fetchList();
    },
    clickRow(item) {
      this.isShow = true;
      this.iframeUrl = item.taskUrl;

      this.$nextTick(() => {
        window.addEventListener("message", (e) => {
          if (e.data.iframeHide) {
            this.isShow = false;
            this.iframeUrl = "";
            this.fetchList();
          } else if (e.data.act == "showRelatedProcess") {
            this.$refs.processDialog.showView(
              e.data.tprocessid,
              e.data.tCanEdit
            );
          }
        });

        this.$refs.iframe.onload = () => {
          const af = this.$refs.iframe.contentWindow["AWSFormMainAPI"];
          af.customCloseFormPage(() => {
            this.isShow = false;
            this.fetchList();
            return true;
          });
        };
      });
    },
    changeSize(value) {
      this.size = value;
      this.fetchList();
    },
    changePage(value) {
      this.page = value;
      this.fetchList();
    },
    download() {
      let obj = {};
      if (this.siftData.length > 0) {
        obj = this.$refs.sift.clickSearchBtn();
      }
      obj.token = this.userToken;

      this.downloadUrl = this.$pramsUrl.getUrl(obj, "newTask/exportTaskList");
      this.$nextTick(() => {
        this.$refs.downloadExcel.click();
      });
    },
  },
};
</script>

<style scoped>
.iframe {
  border: none;
  width: 100%;
  height: calc(100vh - 75px);
  overflow: auto;
}
</style>
